import { useMemo } from "react";
import "../helpers/analytics";

export const useGTM = () => {
  const environnement = useMemo(() => {
    const host = window.location.host;

    if (host.startsWith("localhost") || host.toLowerCase().startsWith("dev"))
      return "dev";
    if (host.toLowerCase().startsWith("test")) return "test";
    if (host.toLowerCase().startsWith("pre")) return "pre";
    return "prod";
  }, []);

  const sendEvent = (eventName: string, eventData: Record<string, any>) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...eventData,
      });
    } else {
      console.warn("GTM not initialized");
      return;
    }
  };

  return { sendEvent, environnement };
};
